import Constants from "expo-constants";

/**
 * Active collaborator state tracked via Yjs Awareness protocol.
 */
export interface ICollaboratorState {
  clientId: number;
  name: string;
  color: string;
  email?: string;
  uid?: string;
}

/**
 * Resolves the collaborative WebSocket server URL for y-websocket.
 * Returns null in local emulator environments where WebSocket upgrades are unsupported.
 * @returns {string | null} The WebSocket endpoint URL or null in emulator.
 */
export function getCollabWebSocketUrl(): string | null {
  const vars = Constants.expoConfig?.extra;
  const functionHost = vars?.FUNCTIONS_EMULATOR_HOST;

  // In local emulator mode, Firebase Functions emulator proxy does not support WebSocket upgrades.
  if (
    vars?.env === "LOCAL" ||
    (functionHost && (functionHost.includes("localhost") || functionHost.includes("127.0.0.1")))
  ) {
    return null;
  }

  if (functionHost) {
    try {
      const parsed = new URL(functionHost);
      const wsProtocol = parsed.protocol === "https:" ? "wss:" : "ws:";
      return `${wsProtocol}//${parsed.host}/demo-memories/europe-north1/collaborationFunc`;
    } catch {
      return null;
    }
  }

  if (typeof window !== "undefined" && window.location) {
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
      return null;
    }
    const isSecure = window.location.protocol === "https:";
    const protocol = isSecure ? "wss:" : "ws:";
    return `${protocol}//europe-north1-memories-dev-247.cloudfunctions.net/collaborationFunc`;
  }

  return null;
}

/**
 * Generates a deterministic pastel color for collaborator presence and cursor flags.
 * @param {string} identifier - User UID or email.
 * @returns {string} Hex color string.
 */
export function getCollaboratorColor(identifier: string): string {
  const palette = [
    "#D97706", // Amber
    "#2563EB", // Cobalt Blue
    "#059669", // Emerald Green
    "#DC2626", // Terracotta Red
    "#7C3AED", // Royal Violet
    "#DB2777", // Rose
    "#0891B2", // Cyan
    "#EA580C", // Deep Orange
  ];
  let hash = 0;
  for (let i = 0; i < identifier.length; i++) {
    hash = identifier.charCodeAt(i) + ((hash << 5) - hash);
  }
  return palette[Math.abs(hash) % palette.length];
}
